import { createLabelsApiTestKit } from './../labels/testkit';
import { createPhoneApiTestKit } from '../phone/testkit';
import { createArticlesApiTestKit } from '../articles/testkit';
import { createTicketsApiTestKit } from '../tickets/testkit';
import { createCallcenterApiTestKit } from '../callcenter/testkit';
import { createUsersApiTestKit } from '../users/testkit';
import { createSettingsApiTestKit } from '../settings/testkit';
import { createWebNotificationsApiTestKit } from '../web-notifications/testkit';
import { createAccountApiTestKit } from '../account/testkit';
import { createFilesApiTestKit } from '../files/testkit';
import { createAdminApiTestKit } from '../admin/testkit';
import { createTenantsApiTestKit } from '../tenants/testkit';
import { createWebhooksApiTestKit } from '../widget/testkit';
import { createKbApiTestKit } from '../kb/testkit';
import { createTeamApiTestKit } from '../team/teskit';
import { createInsightsApiTestKit } from '../insights/teskit';
import { createChatApiTestkit } from '../chat/testkit';
import { createIntegrationsApiTestKit } from '../integrations/teskit';
import { createTeamPerformanceInsightsApiTestkit } from '../insights/team-performance/testkit';
import { createSlaApiTestkit } from '../sla/testkit';
import { createUserStorageApiTestkit } from '../user-storage/testkit';
import { createCompaniesApiTestkit } from '../company/testkit';
import { createMyStatisticsInsightsApiTestkit, createChatInsightsApiTestkit } from '../insights';
import { createMacrosApiTestkit } from '../macros/testkit';
import { createUserRolesApiTestkit } from '../roles/testkit';
import { createWhatsappApiTestKit } from '../whatsapp/testkit';
import { createChatDashboardApiTestkit, createControlRoomApiTestkit, createEmailDashboardApiTestkit, createOmnichannelDashboardApiTestkit } from '../control-room';
import { createAgentAutoRoutingApiTestkit } from '../agent-auto-routing/testkit';
import { createWorkflowsApiTestKit } from '../workflows/testkit';
import { createSmsApiTestKit } from '../sms/testkit';
import { createBrandsApiTestKit } from '../brands/testkit';
import { createSchedulesApiTestKit } from '../schedules/testkit';
import { createWasabiApiTestKit } from '../wasabi/testkit';
import { createTwitterApiTestKit } from '../twitter/testkit';
import { createInstagramApiTestKit } from '../instagram/testkit';
export { createTicketsApiTestKit };
export var createApiTestKit = function () {
    return {
        account: createAccountApiTestKit(),
        admin: createAdminApiTestKit(),
        articles: createArticlesApiTestKit(),
        brands: createBrandsApiTestKit(),
        callcenter: createCallcenterApiTestKit(),
        chat: createChatApiTestkit(),
        companies: createCompaniesApiTestkit(),
        files: createFilesApiTestKit(),
        insights: createInsightsApiTestKit(),
        integrations: createIntegrationsApiTestKit(),
        kb: createKbApiTestKit(),
        labels: createLabelsApiTestKit(),
        macros: createMacrosApiTestkit(),
        userRoles: createUserRolesApiTestkit(),
        myStatistics: createMyStatisticsInsightsApiTestkit(),
        phone: createPhoneApiTestKit(),
        settings: createSettingsApiTestKit(),
        sla: createSlaApiTestkit(),
        team: createTeamApiTestKit(),
        teamPerformance: createTeamPerformanceInsightsApiTestkit(),
        chatInsights: createChatInsightsApiTestkit(),
        tenants: createTenantsApiTestKit(),
        tickets: createTicketsApiTestKit(),
        userStorage: createUserStorageApiTestkit(),
        users: createUsersApiTestKit(),
        whatsapp: createWhatsappApiTestKit(),
        sms: createSmsApiTestKit(),
        webNotifications: createWebNotificationsApiTestKit(),
        widget: createWebhooksApiTestKit(),
        controlRoom: createControlRoomApiTestkit(),
        chatdashboard: createChatDashboardApiTestkit(),
        agentAutoRouting: createAgentAutoRoutingApiTestkit(),
        workflows: createWorkflowsApiTestKit(),
        schedules: createSchedulesApiTestKit(),
        wasabi: createWasabiApiTestKit(),
        twitter: createTwitterApiTestKit(),
        instagram: createInstagramApiTestKit(),
        emailDashboard: createEmailDashboardApiTestkit(),
        omnichannelDashboard: createOmnichannelDashboardApiTestkit(),
    };
};
//# sourceMappingURL=index.js.map